import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { SpeakersPanel } from './SpeakersPanel';
import { PluginPanelContainer } from './shared/PluginPanelContainer';
export function SidebarSlot({ activePanel = 'chat', onClose, }) {
    return (_jsx(SidebarSlotRoot, { children: _jsx(Content, { className: "tv-ui-shiny-border", children: activePanel === 'chat' ? (_jsx(PluginPanelContainer, { slotId: "sidebar" })) : (_jsx(SpeakersPanel, { onClose: onClose })) }) }));
}
const Content = styled.div `
    position: absolute;
    top: 0%;
    height: 100%;
    left: 0%;
    right: 1.5rem;
    overflow: hidden;

    background: rgba(57, 56, 56, 0.6);
    backdrop-filter: blur(50px);
    border: 1.4px solid rgba(255, 255, 255, 0.4);
    border-radius: 16px;
    
    iframe {
        width: 100%;
        height: 100%;
        background: none;
    }
`;
const SidebarSlotRoot = styled.div `
    height: 100%;
    position: relative;
`;
